<footer class="tile-footer" *transloco="let t">
    <section class="split-section" *ngIf="tileFooterData.unitInformation.unitType !== 'ArchivePageUnit'">
        <div class="split-section__left">
            <ng-container *ngFor="let i of tileFooterIcons">
                <bulb-tiles-footer-icon
                    *ngIf="i.visibility"
                    [iconKey]="i.iconKey"
                    [label]="i.label"
                    [alert]="i.alert"
                    [tooltip]="i.tooltip">
                </bulb-tiles-footer-icon>
            </ng-container>
            <p
                class="split-section__left--text"
                *ngIf="!tileFooterData.authorImpliedByContext && tileFooterData.unitInformation.ownerDisplayName
                 && tileFooterData.unitInformation.unitType !== 'AssignmentCompositeUnit'">
                {{ t('tiles.tilesFooter.blockBy') }} {{tileFooterData.unitInformation.ownerDisplayName}}
            </p>
        </div>
        <div class="split-section__center">
          <p *ngIf="tileFooterData.unitInformation.unitType === 'AssignmentCompositeUnit'"
             class="split-section__center--text">
            <span title="{{ t('tiles.tilesFooter.submitted') }}" class="submitted">{{ tileFooterData.assignmentInformation?.noOfSubmissions }}</span> |
            <span title="{{ t('tiles.tilesFooter.assigned') }}" class="assigned">{{ tileFooterData.assignmentInformation?.noOfAssignments }}</span>
          </p>
        </div>
        <div class="split-section__right">
            <bulb-tiles-triple-dot
                *ngIf="hasVisibleMenuItems && (tileFooterData.canEdit || tileFooterData.unitInformation.isPinned)"
                [menuItems]="tileFooterData.menuItems"
                [canEdit]="tileFooterData.canEdit"
                [unit]="tileFooterData.unitInformation">
            </bulb-tiles-triple-dot>
            <p class="split-section__right--text" *ngIf="tileFooterData.isDeleted">
                {{ t('tiles.tilesFooter.deleted', { deleteAfterDays: tileFooterData.unitInformation.deleteAfterDays }) }}
            </p>
        </div>
    </section>
    <section class="archive" *ngIf="tileFooterData.unitInformation.unitType === 'ArchivePageUnit'">
        <p class="archive__text">
            {{ t('tiles.tilesFooter.archive') }} {{ tileFooterData.unitInformation.archivedDate | date :'short' }}
        </p>
    </section>
</footer>
